// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const Range = t.struct({
    max: t.maybe(t.Number),
    min: t.maybe(t.Number)
}, {
    name: 'Range',
    strict: true
});

Range.prototype.isWithinRange = function isWithinRage(num) {

    const isWithinRange = num >= this.min && num <= this.max;

    return isWithinRange;

};

export const getDefaultState = () => new Range({
    max: null,
    min: null
});

export default Range;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/range.js